export { default } from '@material-ui/core/Collapse';
